import { times } from 'lodash';

import { fieldTypeOf } from '../field-types';
import { fieldsOf, holdsFields } from '../format/elements';
import type { FieldElement, FormDefinition, RepeatableGroupField } from '../format/form-definition';
import { formNow } from '../engine/formNow';
import { keptRows } from '../field-types/shared/bounds';

export type FillValues = { [fieldId: string]: unknown };

const startValueOf = (field: FieldElement): unknown => {
  if (holdsFields(field)) return [];
  return structuredClone(field.defaultValue ?? fieldTypeOf(field).emptyValue);
};

export const startValues = (definition: FormDefinition, today: string): FillValues => {
  const values: FillValues = {};
  for (const field of fieldsOf(definition.elements)) values[field.id] = startValueOf(field);

  for (const { field, path, required, range } of formNow(definition, values, today).fields.values()) {
    if (!holdsFields(field)) continue;
    values[path] = times(keptRows(required, range ?? {}), () => newRowValues(field));
  }
  return values;
};

export const newRowValues = (group: RepeatableGroupField): FillValues => {
  const row: FillValues = {};
  for (const field of fieldsOf(group.elements)) row[field.id] = startValueOf(field);
  return row;
};
